import React from "react";
import { Route, Routes } from "react-router-dom";
import ReviewsPage from "../../pages/module-pages/reviews/ReviewsPage";
import NewReviewPage from "../../pages/module-pages/reviews/NewReviewPage";
import UpdateReviewPage from "../../pages/module-pages/reviews/UpdateReviewPage";

export default function ReviewNav() {
  return (
    <Routes>
      <Route path="/" element={<ReviewsPage />} />
      <Route path="/new" element={<NewReviewPage />} />
      <Route path="/update" element={<UpdateReviewPage />} />
    </Routes>
  );
}
